import React, { Component } from 'react';
import { connect } from 'react-redux';

interface Props {
	hash: string | null;
	children: React.ReactNode;
}

function mapStateToProps(state: { accessToken: any }): { hash: string | null } {
	const { accessToken } = state.accessToken;

	return { hash: accessToken !== null ? accessToken.user.id : null };
}

class AccessTokenRemounter extends Component<Props, { show: boolean }> {
	static defaultProps = {
		hash: null,
	};

	state = {
		show: true,
	};

	componentDidUpdate(prevProps: Props) {
		const { hash } = this.props;

		if (prevProps.hash !== hash && prevProps.hash !== null) {
			this.setState({ show: false }, () => this.setState({ show: true }));
		}
	}

	render() {
		return <>{this.state.show ? this.props.children : null}</>;
	}
}

export default connect(mapStateToProps)(AccessTokenRemounter);
